import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { ApproveQuotaWithComments, getQuotaForApproval, rejectMultiple, setState } from "./quotaApprovalSlice";
import { Button, TextField, Typography } from "@mui/material";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function ApproveSingleWithCommentModel() {
   const dispatch = useDispatch();
   const {
      approveSingleWithCommentsModalOpen,
      appMulWithComment,
      selectedRows,
      quotaForApprovalTable,
      quotaForApproval,
      selectedCountryID,
      selectedPeriod,
      selectedQuotaStatus,
      selectedQuotaid,
      searchText
   } = useSelector((store) => store.quota);

   function handleClose() {
      dispatch(setState("approveSingleWithCommentsModalOpen", false));
      dispatch(setState("selectedQuotaid",null));
      dispatch(setState("appMulWithComment",""));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("appMulWithComment", comment));
   }

   function search() {
      dispatch(setState("quotaCustomerBreakdown", null));
      dispatch(setState("quotaDetailsTable", null));
	  dispatch(setState("rejectSelectedComment",''));
	  dispatch(setState("selectedRows",[]));
      dispatch(setState("appMulWithComment",''));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;

      const obj = {
         countryId,
         period,
         quotaStatus,
         logedUser,
         searchText: searchText
      };
      dispatch(getQuotaForApproval(obj));
   }

   function approveSelected() {
      handleClose();
      const quota = quotaForApproval.find(
        (q) => q.quotaId === selectedQuotaid
     );
      const user = JSON.parse(localStorage.getItem("data"));
      const obj  = {
        ...quota,
        approveComments: appMulWithComment,
        user
        }
      console.log("Approve_Quota_ApproveSelectedWithComment", obj);
      dispatch(ApproveQuotaWithComments(obj)).then(() =>
      {
         search();
      });
   }

   return (
      <Box>
         <Modal open={approveSingleWithCommentsModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
                  size="large"
                  multiline
                  rows={6}
                  style={{overflowY:'auto'}}
                  value={appMulWithComment}
                  onChange={setComment}
               />
               <br />
               <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<Button
						   sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
                        mr:2,
                        "&:hover": {
                        bgcolor: "darkred.main",
                        color: "white.main",
                        },
                     }}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
						   sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
                        "&:hover": {
                        bgcolor: "darkred.main",
                        color: "white.main",
                        },
                     }}
							onClick={approveSelected}
						>
							Approve
						</Button>
					</Box>
            </Box>
         </Modal>
      </Box>
   );
}
